@if (readOnly) {
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container>
      @if (loading()) {
        <glxy-loading-spinner [inline]="true" />
      } @else {
        {{ displayName$ | async }}
      }
    </ng-container>
  </div>
} @else if (loading()) {
  <glxy-form-field>
    <glxy-label> {{ label }} </glxy-label>
    <div glxyPrefix>
      <glxy-loading-spinner [inline]="true" />
    </div>
    <input matInput />
  </glxy-form-field>
} @else {
  <glxy-form-field>
    <glxy-label> {{ label }} </glxy-label>
    <input
      #searchInput
      type="text"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      [placeholder]="'MODEL_DRIVEN_FORM.SELECT_PROMPT' | translate"
      (input)="handleSearchTermInput()"
      (focus)="handleSearchTermInput()"
      (blur)="saveField()"
      (keydown.enter)="$event.preventDefault()"
      />
    @if (control.value?.id) {
      <button matSuffix mat-icon-button class="crm-field-clear-button" aria-label="Clear" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" requireSelection>
      @for (option of options$ | async; track option) {
        <mat-option [value]="option">
          {{ option?.displayName }}
        </mat-option>
      }
    </mat-autocomplete>
  </glxy-form-field>
}
